<template>
<transition appear name="fade">
    <div v-if="showed" id="rgpd">
        <div class="container">
            <!-- <p v-if="pathname == '/login'"><small>Permiscole collecte vos données à caractère personnel à des fins de gestion de votre compte utilisateur. Ces données sont nécessaires pour pouvoir vous offrir un espace personnalisé. Conformément à la
                loi Informatique et
                libertés
                du 6 janvier 1978, vous bénéficiez d'un droit d'accès, de rectification et de suppression de vos données. Vous pouvez également vous opposer, pour un motif légitime, à l'utilisation de vos données. Vous seul pouvez exercer ces
                droits
            <p><b><i class="fas fa-cookie-bite fa-fw" style="color:chocolate"></i> Cookies</b><br />
                sur vos propres données en écrivant à TribLearn - 8 cours de bercy 03000 Moulins et en joignant une photocopie de votre pièce d'identité.</small></p> -->
            <div class="row align-items-center justify-content-center text-center text-md-left">
               <div class="col-md-9  line1">
                  <small>En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de Cookies ainsi que la politique de gestion des données personnelles au sens du RGPD. <a href="/rgpd">En savoir plus.</a></small>
               </div>
               <div class="col-md-3 pt-2 pt-md-0">
                   <button @click="hide" class="btn btn-primary">J'ai compris</button>
               </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    props: [],
    mounted() {
        this.pathname = window.location.pathname;
        this.show();
    },
    data: () => ({
        pathname: '',
        showed: false
    }),
    methods: {
        show() {
            // console.info('[rgpd]', 'show', getCookie('rgpd'));
            if (getCookie('rgpd') != 'approved') {
                this.showed = true;
            }

        },
        hide() {
            // console.info('[rgpd]', 'hide');
            this.showed = false;
            setCookie('rgpd', 'approved', 2629800 * 13); // 2629800 = 1 month
            window.location.reload();
        }
    }
}
</script>
